import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { TreeSelectInput } from './components/TreeSelectInput.js';
import { useTreeSelectCanonicalFieldValue } from './hooks/useTreeSelectCanonicalFieldValue.js';
import { InputWrapper } from '../InputWrapper/InputWrapper.js';

function RHFTreeSelect(_a) {
  var {
      forwardedRef
    } = _a,
    props = __rest(_a, ["forwardedRef"]);
  const {
    checkboxSelectionBehavior,
    name,
    options,
    selectionMode
  } = props;
  const formContext = useFormContext();
  useTreeSelectCanonicalFieldValue({
    checkboxSelectionBehavior,
    formContext,
    name,
    options,
    selectionMode
  });
  return jsx(Controller, {
    name: name,
    control: formContext.control,
    rules: {
      required: Boolean(props.required)
    },
    render: _ref => {
      let {
        field,
        fieldState
      } = _ref;
      return jsx(InputWrapper, Object.assign({}, props, {
        field: field,
        fieldState: fieldState,
        children: jsx(TreeSelectInput, Object.assign({}, props, {
          appendTo: document.body,
          forwardedRef: forwardedRef,
          invalid: fieldState.invalid || props.invalid,
          name: name,
          value: field.value,
          disabled: field.disabled || props.disabled,
          onBlur: event => {
            var _a;
            field.onBlur();
            (_a = props.onBlur) === null || _a === void 0 ? void 0 : _a.call(props, event);
          },
          onChange: event => {
            var _a;
            field.onChange(event);
            (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, event);
          }
        }))
      }));
    }
  });
}
function TreeSelectComponent(props, ref) {
  const {
    name,
    value
  } = props;
  const formContext = useFormContext();
  const isControlled = typeof value !== 'undefined';
  if (isControlled || !formContext || !name) {
    return jsx(InputWrapper, Object.assign({}, props, {
      children: jsx(TreeSelectInput, Object.assign({}, props, {
        forwardedRef: ref,
        invalid: Boolean(props.errorMessage || props.invalid)
      }))
    }));
  }
  return jsx(RHFTreeSelect, Object.assign({}, props, {
    forwardedRef: ref,
    name: name
  }));
}
const TreeSelect = /*#__PURE__*/forwardRef(TreeSelectComponent);
TreeSelect.displayName = 'TreeSelect';

export { TreeSelect };
